import 'css-chunksrc/client/pages/zonesPage/reportsPage/styles.scss';export default {
  "reportsPage": "_reportsPage_mzydc_1",
  "main": "_main_mzydc_7",
  "reverse": "_reverse_mzydc_16",
  "section": "_section_mzydc_20",
  "title": "_title_mzydc_24",
  "reportsList": "_reportsList_mzydc_30",
  "report": "_report_mzydc_1"
};